export class OnDemandVideoFolderVM {

  name: string;

  icon: string;

  vidoes: OnDemandVideoVM[];

}

export class OnDemandVideoVM {

  name: string;

  uri: string;

  poster: string;

}
